import React, { useMemo, useRef, useState, useEffect } from "react";
import * as S from "./PatientInfo.style";
import * as P from "../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import ZaiaInputForm from "../../../../zaiaComponents/zaiaInputForm";
import ZaiaSelectForm from "../../../../zaiaComponents/zaiaSelectForm";
import * as Yup from "yup";
import { Formik, useFormikContext } from "formik";
import { QUERY_GET_CITIES_ORDER_NAME, QUERY_GET_COUNTRIES, QUERY_GET_COUNTRIES_ORDER_NAME, QUERY_GET_COUNTRIES_ORDER_PHONECODE, QUERY_GET_STATES_ORDER_NAME } from "../../../../../graphql/queries/Country";
import { QUERY_GET_DOCUMENT_TYPES } from "../../../../../graphql/queries/DocumentType";
import { useMutation, useQuery } from "@apollo/client";
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaInput from "../../../../zaiaComponents/zaiaInput";
import { MUTATION_UPDATE_PATIENT } from "../../../../../graphql/mutations/User";
import { MUTATION_UPDATE_USER_TO_PROCESS_ID } from "../../../../../graphql/mutations/UserToProcess";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent/ZaiaModalResponseContent";

const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;
const correctImg = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-success.svg`;


function PatientInfo({
  setShowInfo,
  selectedPatient
}) {
  const { t, i18n: { language } } = useTranslation("global");
  const formik = useFormikContext();
  const [editionActive, setEditionActive] = useState(false);
  const [insuranceCodes, setInsuranceCodes] = useState([]);
  const [insuranceCodesEdited, setInsuranceCodesEdited] = useState([]);
  const [updatePatient, { loading: updatePatientLoading, error: updatePatientError }] = useMutation(MUTATION_UPDATE_PATIENT);
  const [updatePatientInsuranceCodes, { loading: updatePatientInsuranceCodesLoading, error: updatePatientInsuranceCodesError }] = useMutation(MUTATION_UPDATE_USER_TO_PROCESS_ID);
  const [errorText, setErrorText] = useState('');  
  const [successText, setSuccessText] = useState('');
  const [formSuccess, setFormSuccess] = useState(null);

  const handleSubmit = async (values, { resetForm }) => {

    // filter items modified comparing insuranceCodesEdited and insuranceCodes where code is not the same
    const modifiedCodes = insuranceCodesEdited.filter((editedCode) => {
      const originalCode = insuranceCodes.find(code => code.id === editedCode.id);
      return originalCode && originalCode.code !== editedCode.code;
    });

    //filter items modified comparing values and selectedPatient
    const initialValues = {
      name: selectedPatient?.name || '',
      lastname: selectedPatient?.lastname || '',
      email: selectedPatient?.email || '',
      country: selectedPatient?.countryId || '',
      city: selectedPatient?.cityId || '',
      typeDocument: selectedPatient?.documentType || '',
      document: selectedPatient?.documentNumber || '',
      birthdate: selectedPatient?.birthdate || '',
      sex: selectedPatient?.gender || '',
      numberCountry: selectedPatient?.countryPhoneId || '',
      number: selectedPatient?.phone || '',
      carerName: selectedPatient?.nameCarer || '',
      carerLastname: selectedPatient?.lastnameCarer || '',
      carerNumberCountry: selectedPatient?.countryPhoneCarerId || '',
      carerNumber: selectedPatient?.phoneCarer || '',
      address: selectedPatient?.address || ''
    };

    const modifiedValues = {};
    Object.keys(values).forEach(key => {
      if (values[key] !== initialValues[key]) {
        modifiedValues[key] = values[key];
      }
    });

    console.log("Modified Insurance Codes:", modifiedCodes);
    console.log("Modified Patient Values:", modifiedValues);

    //convert modifiedValues to patientChanges
    const patientChanges = {};
    Object.keys(modifiedValues).forEach(key => {

      console.log("joya", key);
      

      if(key === 'name'){
        patientChanges['name'] = modifiedValues[key];
      } else if(key ==='lastname'){
        patientChanges['lastname'] = modifiedValues[key];
      } else if(key === 'country'){
        patientChanges['countryId'] = modifiedValues[key];
      }else if(key === 'city'){
        patientChanges['cityId'] = modifiedValues[key];
      }else if(key === 'typeDocument'){
        patientChanges['documentType'] = modifiedValues[key];
      } else if(key === 'document'){
        patientChanges['documentNumber'] = modifiedValues[key];
      }else if(key === 'numberCountry'){
        patientChanges['countryPhoneId'] = modifiedValues[key];
      }else if(key === 'carerNumberCountry'){
        patientChanges['countryPhoneCarerId'] = modifiedValues[key];
      }else if(key === 'sex'){
        patientChanges['gender'] = modifiedValues[key];
      }else if(key === 'number'){
        patientChanges['phone'] = modifiedValues[key].toString();
      }else if(key === 'carerNumber'){
        patientChanges['phoneCarer'] = modifiedValues[key].toString();
      }else if(key === 'carerName'){
        patientChanges['nameCarer'] = modifiedValues[key];
      }else if(key === 'carerLastname'){
        patientChanges['lastnameCarer'] = modifiedValues[key];
      }else if(key === 'birthdate'){
        patientChanges['birthdate'] = modifiedValues[key];
      }
    });

    console.log("Selected Patient:", modifiedValues);

    
    console.log("Patient Changes:", patientChanges);
    
    
    if (Object.keys(modifiedValues).length > 0) {
      try {
        const updatedPatient = await updatePatient({
          variables: {
            patientId: selectedPatient?.id,
            patientChanges: patientChanges
          }
        });
        if (updatedPatient?.data?.update_user?.affected_rows > 0) {
          console.log("Patient updated successfully");
          setFormSuccess(true);
          setSuccessText(t("globally.changesSaved"));
        }
      } catch (error) {
        setFormSuccess(false);
        setErrorText(t("globally.genericError"));
        console.error("Error updating patient:", error);
      }
    }

    if(modifiedCodes.length > 0){
      modifiedCodes.forEach(async (code) => {
        try {
          const updatedPatient = await updatePatientInsuranceCodes({
            variables: {
              userToProcessId: code?.id,
              userToProcessChanges: {
                securityCode: code?.code
              }
            }
          });
          if (updatedPatient?.data?.update_user_to_process?.affected_rows > 0) {
            console.log("Patient updated successfully");
            setFormSuccess(true);
            setSuccessText(t("globally.changesSaved"));
          }
        } catch (error) {
          setFormSuccess(false);
          setErrorText(t("globally.genericError"));
          console.error("Error updating patient:", error);      
        }
      })
    }

    if(!updatePatientError && !updatePatientInsuranceCodesError){
      setEditionActive(false);
    }
    
    // let submitPhoto = { load: false, success: true }
    // let fileImg
    // if (imageData && doctorDataQuery?.doctor[0]?.picture !== imageData) {
    //   submitPhoto.load = true;
    //   try {
    //     fileImg = await changeDoctorImg({
    //       variables: {
    //         pictureInBase64: imageData.split('base64,')[1]
    //       },
    //     });
    //   } catch (err) {
    //     submitPhoto.success = false;
    //   }
    // } else {
    //   submitPhoto.load = false;
    // }

    // let modifydoctorData;

    // const modifyInfo = getModifyInfo(values, fileImg);

    // const { doctorData } = doctorDataQuery?.doctor[0];

    // // doctor data
    // if (values.primarySpeciality && (values.primarySpeciality !== doctorData[0]?.medicalField)) {
    //   modifydoctorData = { 
    //     medicalField: values.primarySpeciality 
    //   };
    //   if (!doctorData[0]) {
    //     modifydoctorData.universityName = "";
    //   }
    // }

    // changeInfoDoctor(modifyInfo, modifydoctorData, submitPhoto, resetForm);
  }

  if(formSuccess) {
    return <>
      <ZaiaModalResponseContent
        button1={() => setShowInfo(false)}
        button1Text={t("globally.close")}
        formSuccess={formSuccess}
        title={t("globally.changesSaved")}
        subtitle={successText}
      />
    </> 
  }

  if(updatePatientLoading || updatePatientInsuranceCodesLoading){
    return <ZaiaReaction
      zaiaImg={logoZaiaLoading}
      sizeText="20px"
      textColor="var(--blue-color)"
      widthimg="110px"
    />
  }

  if(formSuccess === false){
    return <ZaiaModalResponseContent
      button1={() => setFormSuccess(null)}
      button1Text={t("globally.tryAgain")}
      formSuccess={false}
      title={errorText}
    />
  }

  return (
    <>
      <S.PatientInfo>
        <Formik
          initialValues={{
            name: selectedPatient?.name || '',
            lastname: selectedPatient?.lastname || '',
            email: selectedPatient?.email || '',
            country: selectedPatient?.countryId || '',
            state: selectedPatient?.city?.stateId || '',
            city: selectedPatient?.cityId || '',
            typeDocument: selectedPatient?.documentType || '',
            document: selectedPatient?.documentNumber || '',
            birthdate: selectedPatient?.birthdate || '',
            sex: selectedPatient?.gender || '',
            numberCountry: selectedPatient?.countryPhoneId || '',
            number: selectedPatient?.phone || '',
            carerName: selectedPatient?.nameCarer || '',
            carerLastname: selectedPatient?.lastnameCarer || '',
            carerNumberCountry: selectedPatient?.countryPhoneCarerId || '',
            carerNumber: selectedPatient?.phoneCarer || '',
            address: selectedPatient?.address || ''
          }}
          enableReinitialize={true}
          validationSchema={Yup.object({
            name: Yup.string()
              .required(t("register.validation.required")),
            lastname: Yup.string()
              .required(t("register.validation.required")),
            email: Yup.string()
              .email(t("register.validation.email"))
              .required(t("register.validation.required")),
            country: Yup.string()
              .when("city", { 
                is: (city) => city,
                then: Yup.string().required(t("register.validation.required"))
              }),
            state: Yup.string(),
            city: Yup.string(),
            typeDocument: Yup.string(),
            document: Yup.string(),
            birthdate: Yup.string(),
            sex: Yup.string(),
            numberCountry: Yup.string(),
            number: Yup.string(),
            carerName: Yup.string(),
            carerLastname: Yup.string(),
            carerNumberCountry: Yup.string(),
            carerNumber: Yup.string(),
            address: Yup.string(),
          })}
          onSubmit={handleSubmit}
        >
          {() => (
            <>
              <PatientFormFields
                t={t}
                editionActive={editionActive}
                setShowInfo={setShowInfo}
                setEditionActive={setEditionActive}
                selectedPatient={selectedPatient}
                insuranceCodesEdited={insuranceCodesEdited}
                setInsuranceCodesEdited={setInsuranceCodesEdited}
                insuranceCodes={insuranceCodes}
                setInsuranceCodes={setInsuranceCodes}
              />
            </>
          )}
        </Formik>
      </S.PatientInfo>
    </>
  );
}

function PatientFormFields({
  editionActive,
  setShowInfo,
  setEditionActive,
  selectedPatient,
  insuranceCodesEdited,
  setInsuranceCodesEdited,
  insuranceCodes,
  setInsuranceCodes
}) {

  const { t, i18n: { language } } = useTranslation("global");
  const formik = useFormikContext();
  const { values, setFieldValue } = formik;
  const [selectedCountry, setSelectedCountry] = useState(selectedPatient?.countryId || null);
  const [selectedState, setSelectedState] = useState(selectedPatient?.city?.stateId || null);

  const { data: documentTypeData, loading: documentTypeLoading, error: documentTypeError } = useQuery(QUERY_GET_DOCUMENT_TYPES);
  const { data: countriesPhoneData, loading: countriesPhoneLoading, error: countriesPhoneError } = useQuery(QUERY_GET_COUNTRIES_ORDER_PHONECODE);
  const { data: countriesData, loading: countriesLoading, error: countriesError } = useQuery(QUERY_GET_COUNTRIES_ORDER_NAME);
  const { data: statesData, loading: statesLoading, error: statesError } = useQuery(QUERY_GET_STATES_ORDER_NAME, {
    variables: { countryId: selectedCountry }
  });
  const { data: citiesData, loading: citiesLoading, error: citiesError } = useQuery(QUERY_GET_CITIES_ORDER_NAME, {
    variables: { stateId: selectedState }
  });

  useEffect(() => {
    const insureranceCodesData = selectedPatient?.userToProcesses.map(userToProcess => {
      return {
        id: userToProcess.id,
        process: userToProcess.process,
        code: userToProcess.securityCode
      };
    });
    setInsuranceCodesEdited(insureranceCodesData ? [...insureranceCodesData] : []);
    setInsuranceCodes(insureranceCodesData ? [...insureranceCodesData] : []);
  }, [selectedPatient, editionActive]);

  useEffect(() => {
    const { values } = formik;

    if (values?.country !== selectedCountry) {
      setSelectedCountry(values.country);
      setSelectedState(null);
      setFieldValue("state", '');
      setFieldValue("city", '');
    }

    if (values?.state !== selectedState) {
      setSelectedState(values.state);
      setFieldValue("city", '');
    }

  }, [formik]);

  const genres = [
    {
      id: "femenine",
      name: t("globally.female"),
    },
    {
      id: "masculine",
      name: t("globally.male"),
    }
  ]

  const changeInsuranceCode = (id, value) => {
    setInsuranceCodesEdited(prevCodes => prevCodes.map(code => {
      if (code.id === id) {
        return {
          ...code,
          code: value
        };
      }
      return code;
    }));
  }

  const cancelEdition = () => {
    setEditionActive(false);
    formik.resetForm();
    setInsuranceCodesEdited([...insuranceCodes]);
  }
  
  if (documentTypeLoading || countriesLoading)
    return <ZaiaReaction
      zaiaImg={logoZaiaLoading}
      sizeText="20px"
      textColor="var(--blue-color)"
      widthimg="110px"
    />

  if (documentTypeError || countriesError)
    return <ZaiaReaction
      zaiaImg={logoZaiaAlert}
      sizeText="20px"
      textColor="var(--blue-color)"
      widthimg="110px"
    />

  return (
    <form onSubmit={formik.handleSubmit}> {/* Puedes usar el elemento form aquí */}
      <div className="header">
        <div className="header__left">
          <div className="header__button header__button--margin-right">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              icon={"zaia-icono-atras"}
              iconSize={"11px"}
              widthComplete={false}
              onClick={() => setShowInfo(false)}
            />
          </div>
          <div className="header__text">
            {t("globally.morePatientInfo")}
          </div>
        </div>
        <div className="header__right">
          {
            editionActive
              ? <>
                <div className="header__button header__button--margin-left">
                  <FlorenzButton
                    typeStyle={"secondaryWhite"}
                    type="button"
                    size="s"
                    text={t("globally.cancel")}
                    iconSize={"11px"}
                    onClick={() => {cancelEdition()}}
                  />
                </div>
                <div className="header__button header__button--margin-left">
                  <FlorenzButton
                    typeStyle={"success"}
                    type="submit"
                    size="s"
                    text={t("globally.saveChanges")}
                    iconSize={"11px"}
                  />
                </div>
              </>
              : <div className="header__button header__button--margin-left">
                <FlorenzButton
                  typeStyle={"secondaryWhite"}
                  type="button"
                  size="s"
                  text={t("globally.editInformation")}
                  icon={"zaia-icono-editar"}
                  onClick={() => setEditionActive(true)}
                  iconSize={"11px"}
                />
              </div>
          }
        </div>
      </div>
      <div className="inputs-container">
        <div className="inputs-flex">
          <div className="input-content">
            <span>{t("globally.name")}</span>
            <ZaiaInputForm
              placeholder={t("globally.name")}
              type="text"
              name="name"
              borderRadius={"14px"}
              fontSize={"17px"}
              textColor={"#1F1F52"}
              padding={"22px 20px 21px"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span>{t("profile.lastname")}</span>
            <ZaiaInputForm
              placeholder={t("profile.lastname")}
              type="text"
              name="lastname"
              borderRadius={"14px"}
              fontSize={"17px"}
              textColor={"#1F1F52"}
              padding={"22px 20px 21px"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content">
            <span>{t("globally.email")}</span>
            <ZaiaInputForm
              placeholder={t("globally.email")}
              type="text"
              name="email"
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#d8d8f0"}
              disabled={true}
              onlyBottomBorder
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content input-content--display-flex">
            <span>{t("globally.country")}</span>
            <ZaiaSelectForm
              type="select"
              name="country"
              maxHeightList={"200px"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                countriesData?.country.map((country) => {
                  return ({
                    value: country.id,
                    text: country.name
                    // text: country.sortname,
                    // textBold: '+' + country.phonecode
                  })
                })
              }
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content input-content--display-flex">
            <span>{t("globally.state")}</span>
            <ZaiaSelectForm
              type="select"
              name="state"
              maxHeightList={"200px"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={!values.country ? "#EDEDFF" : "#FFFFFF"}
              onlyBottomBorder
              disabled={
                !editionActive || !selectedCountry
              }
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                statesData?.state.map((state) => {
                  return ({
                    value: state.id,
                    text: state.name
                    // text: country.sortname,
                    // textBold: '+' + country.phonecode
                  })
                })
              }
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content input-content--display-flex">
            <span>{t("globally.city")}</span>
            <ZaiaSelectForm
              type="select"
              name="city"
              maxHeightList={"200px"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={!values.state ? "#EDEDFF" : "#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive || !selectedState}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                citiesData?.city.map((city) => {
                  return ({
                    value: city.id,
                    text: city.name
                  })
                })
              }
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content">
            <span>{t("profile.document")}</span>
            <ZaiaSelectForm
              type="select"
              name="typeDocument"
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              borderColor={"#6C6BCC"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#3E3DA3"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                documentTypeData?.enDocumentType.map((type) => {
                  return ({
                    value: type.value,
                    text: type.comment.code
                  })
                })
              }
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span>&nbsp;</span>
            <ZaiaInputForm
              placeholder={t("profile.document")}
              type="text"
              name="document"
              icon="icono-id"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              textColor={"#1F1F52"}
              padding={"22px 20px 21px"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span>{t("profile.birthday")}</span>
            <ZaiaInputForm
              type="date"
              name="birthdate"
              borderRadius={"14px"}
              fontSize={"17px"}
              textColor={"#1F1F52"}
              padding={"22px 20px 21px"}
              disabledColor={"#FFFFFF"}
              activeBorder={false}
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content">
            <span>{t("globally.biologicalSex")}</span>
            <ZaiaSelectForm
              type="select"
              name="sex"
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              borderColor={"#6C6BCC"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#3E3DA3"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                genres.map((genre) => {
                  return ({
                    value: genre.id,
                    text: genre.name
                  })
                })
              }
            />
          </div>
        </div>

        <div className="inputs-title inputs-title--second">{t("globally.contactInfo")}</div>
        <div className="inputs-flex">
          <div className="input-content input-content--small-select">
            <ZaiaSelectForm
              type="select"
              name="numberCountry"
              maxHeightList={"200px"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#3E3DA3"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                countriesPhoneData?.country.map((country) => {
                  return ({
                    value: country.id,
                    text: "+" + country.phonecode
                    // text: country.sortname,
                    // textBold: '+' + country.phonecode
                  })
                })
              }
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span></span>
            <ZaiaInputForm
              placeholder={t("globally.phoneNumber")}
              type="number"
              name="number"
              icon="icono-telefono"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content">
            <span>{t("globally.caregiverName")}</span>
            <ZaiaInputForm
              placeholder={t("globally.caregiverName")}
              type="text"
              name="carerName"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span>{t("globally.caregiverLastName")}</span>
            <ZaiaInputForm
              placeholder={t("globally.caregiverLastName")}
              type="text"
              name="carerLastname"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
        </div>
        <div className="inputs-flex">
          <div className="input-content input-content--small-select">
            <ZaiaSelectForm
              type="select"
              name="carerNumberCountry"
              maxHeightList={"200px"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              fontFamily={"Nunito Sans Bold"}
              textColor={"#3E3DA3"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              onlyBottomBorder
              disabled={!editionActive}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              items={
                countriesPhoneData?.country.map((country) => {
                  return ({
                    value: country.id,
                    text: "+" + country.phonecode
                    // text: country.sortname,
                    // textBold: '+' + country.phonecode
                  })
                })
              }
            />
          </div>
          <div className="input-separator"></div>
          <div className="input-content">
            <span></span>
            <ZaiaInputForm
              placeholder={t("globally.phoneNumber")}
              type="number"
              name="carerNumber"
              icon="icono-telefono"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
        </div>
        {/* <div className="inputs-flex">
          <div className="input-content">
            <span>{t("globally.address")}</span>
            <ZaiaInputForm
              placeholder={t("globally.address")}
              type="text"
              name="address"
              icon="icono-telefono"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
        </div> */}
        <div className="inputs-title inputs-title--second">{t("globally.insuranceCodes")}</div>
        {
          insuranceCodesEdited.map((insuranceCode) => {
            return (
              <div className="inputs-flex" key={insuranceCode.id}>
                <div className="input-label">
                  {P.dataTranslation(insuranceCode.process?.processName, language)}
                </div>
                <div className="input-content">
                  <ZaiaInput
                    name={`insuranceCode-${insuranceCode.id}`}
                    type="text"
                    placeholder={P.dataTranslation(insuranceCode.process?.processName, language) + " code"}
                    iconColor={"#36369B"}
                    borderRadius={"14px"}
                    fontSize={"17px"}
                    padding={"22px 20px 21px"}
                    textColor={"#1F1F52"}
                    borderColor={"#6C6BCC"}
                    disabledColor={"#FFFFFF"}
                    disabledtextcolor={"#3E3E5B"}
                    disabledIconColor={"#878792"}
                    onlyBottomBorder
                    disabled={!editionActive}
                    value={insuranceCode.code ? insuranceCode.code : ""}
                    getText={(e) => {
                      changeInsuranceCode(insuranceCode.id, e);
                    }}
                  />
                </div>
              </div>
            )
          })
        }
        {/* <div className="inputs-flex">
          <div className="input-content">
            <span>{"Insurance code"}</span>
            <ZaiaInputForm 
              placeholder={"Insurance code"}
              type="text"
              name="insuranceCode"
              iconColor={"#36369B"}
              borderRadius={"14px"}
              fontSize={"17px"}
              padding={"22px 20px 21px"}
              textColor={"#1F1F52"}
              borderColor={"#6C6BCC"}
              disabledColor={"#FFFFFF"}
              disabledtextcolor={"#3E3E5B"}
              disabledIconColor={"#878792"}
              onlyBottomBorder
              disabled={!editionActive}
            />
          </div>
        </div> */}
      </div>
    </form>
  );
}
//

export default PatientInfo